import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=3fa0dea0&"
import script from "./RadioGroup.vue?vue&type=script&lang=js&"
export * from "./RadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports